import { useEffect, useState } from "react";
import {
  Button,
  ButtonGroup,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";

import DatePicker from "react-datepicker";
import { DateValidater, SelectOnlyDate } from "../../helper/Method";
import { GetLanguageString } from "../Components";

const dateRangeValidation = {
  startDate: null,
  endDate: null,
};

const LFCFilter = ({ values, setValues, showFullDate = false }) => {
  const [searchEnterDates, setSearchEnterDates] = useState(false);
  const [searchByFilters, setSearchByFilters] = useState(true);

  const [all, setAll] = useState("primary");
  const [lastThreeMonth, setLastThreeMonth] = useState("white");
  const [lastSixMonth, setLastSixMonth] = useState("white");
  const [lastYear, setLastYear] = useState("white");

  useEffect(() => {
    if (!searchEnterDates) {
      setAll("primary");
      setLastThreeMonth("white");
      setLastSixMonth("white");
      setLastYear("white");
    }
  }, [searchEnterDates]);

  const handleMonthStatus = (e) => {
    const { value } = e.target;
    let date = new Date();
    let currentDate = new Date();
    if (value === "0") {
      setAll("primary");
      setLastThreeMonth("white");
      setLastSixMonth("white");
      setLastYear("white");
      date.setDate(1);
      setValues({
        ...values,
        startDate: null,
        endDate: null,
      });
    } else if (value === "2") {
      setAll("white");
      setLastThreeMonth("white");
      setLastSixMonth("primary");
      setLastYear("white");
      let firstDay = new Date(date.getFullYear(), date.getMonth() - 5, 1);
      setValues({
        ...values,
        startDate: SelectOnlyDate(firstDay),
        endDate: SelectOnlyDate(currentDate),
      });
    } else if (value === "3") {
      setAll("white");
      setLastSixMonth("white");
      setLastThreeMonth("white");
      setLastYear("primary");
      let firstDay = new Date(date.getFullYear(), date.getMonth() - 11, 1);
      setValues({
        ...values,
        startDate: SelectOnlyDate(firstDay),
        endDate: SelectOnlyDate(currentDate),
      });
    } else if (value === "4") {
      setAll("white");
      setLastSixMonth("white");
      setLastThreeMonth("primary");
      setLastYear("white");
      let firstDay = new Date(date.getFullYear(), date.getMonth() - 2, 1);
      setValues({
        ...values,
        startDate: SelectOnlyDate(firstDay),
        endDate: SelectOnlyDate(currentDate),
      });
    }
  };

  const [dateValidations, setDateValidations] = useState(dateRangeValidation);

  useEffect(() => {
    if (searchByFilters) {
      setDateValidations(dateRangeValidation);
    }
  }, [searchByFilters]);

  const handleInputChangeStartDate = (value) => {
    if (DateValidater(value, values.endDate)) {
      setValues({
        ...values,
        startDate: SelectOnlyDate(value),
      });
      setDateValidations(dateRangeValidation);
    } else {
      setDateValidations({
        ...dateValidations,
        startDate: (
          <GetLanguageString props="common_start_date_validation_message" />
        ),
      });
    }
  };

  const handleInputChangeEndDate = (value) => {
    if (DateValidater(values.startDate, value)) {
      setValues({
        ...values,
        endDate: SelectOnlyDate(value),
      });
      setDateValidations(dateRangeValidation);
    } else {
      setDateValidations({
        ...dateValidations,
        endDate: (
          <GetLanguageString props="common_end_date_validation_message" />
        ),
      });
    }
  };

  const handleSearchDates = (name) => {
    if (name === "enterDates") {
      setSearchEnterDates(true);
      setSearchByFilters(false);
    } else if (name === "filters") {
      setSearchEnterDates(false);
      setSearchByFilters(true);
      let tempDate = new Date();
      tempDate.setDate(1);
      setValues({
        ...values,
        startDate: null,
        endDate: null,
      });
    }
  };

  return (
    <Row className="m-t-md">
      <Col md="6">
        <Label for="filters">
          {" "}
          <Input
            id="filters"
            type="radio"
            checked={searchByFilters}
            onChange={() => {
              handleSearchDates("filters");
            }}
          />{" "}
          {
            <GetLanguageString props="event_event_wise_attendance_search_filters" />
          }
        </Label>
        <Row>
          <ButtonGroup style={{ padding: 32 }}>
            <Button
              disabled={searchEnterDates}
              color={all}
              value={0}
              onClick={handleMonthStatus}
            >
              {<GetLanguageString props="all" />}
            </Button>
            <Button
              disabled={searchEnterDates}
              color={lastThreeMonth}
              value={4}
              onClick={handleMonthStatus}
            >
              {<GetLanguageString props="quick_reports4_3_months" />}
            </Button>
            <Button
              disabled={searchEnterDates}
              color={lastSixMonth}
              value={2}
              onClick={handleMonthStatus}
            >
              {<GetLanguageString props="funds_report_6_months" />}
            </Button>
            <Button
              disabled={searchEnterDates}
              color={lastYear}
              value={3}
              onClick={handleMonthStatus}
            >
              {<GetLanguageString props="funds_report_year" />}
            </Button>
          </ButtonGroup>
        </Row>
      </Col>{" "}
      <Col md="6">
        <Label for="enterDates">
          {" "}
          <Input
            id="enterDates"
            type="radio"
            checked={searchEnterDates}
            onChange={() => {
              handleSearchDates("enterDates");
            }}
          />{" "}
          {
            <GetLanguageString props="event_event_wise_attendance_search_enter_date" />
          }
        </Label>
        <Row>
          <Col md="6">
            <FormGroup>
              <Label className="col-form-label">
                {<GetLanguageString props="courses_start_date" />}
              </Label>
              <DatePicker
                disabled={searchByFilters}
                showMonthYearPicker={!showFullDate}
                showYearDropdown={showFullDate}
                openToDate={values.startDate}
                className="form-control"
                dateFormat={showFullDate ? "dd/MM/yyyy" : "MMM yyyy"}
                selected={values.startDate}
                onChange={handleInputChangeStartDate}
              />
              {dateValidations.startDate && (
                <h4 className="text-error">{dateValidations.startDate}</h4>
              )}
            </FormGroup>
          </Col>
          <Col md="6">
            <FormGroup>
              <Label className="col-form-label">
                {<GetLanguageString props="courses_end_date" />}
              </Label>
              <DatePicker
                disabled={searchByFilters}
                showMonthYearPicker={!showFullDate}
                showYearDropdown={showFullDate}
                className="form-control"
                dateFormat={showFullDate ? "dd/MM/yyyy" : "MMM yyyy"}
                selected={values.endDate}
                onChange={handleInputChangeEndDate}
              />
              {dateValidations.endDate && (
                <h4 className="text-error">{dateValidations.endDate}</h4>
              )}
            </FormGroup>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default LFCFilter;
